import { useNavigate } from 'react-router-dom';

import CompleteIcon from '@/assets/img/icon/complete.svg';

import * as S from './style';

const SignUpComplete = () => {
	const navigate = useNavigate();

	return (
		<S.FormContainer>
			<S.Container>
				<S.ImgBox>
					<img src={CompleteIcon} alt="회원가입 완료" />
				</S.ImgBox>
				<S.Title>회원가입이 완료되었습니다!</S.Title>
			</S.Container>
			<S.NextButton type="button" onClick={() => navigate('/auth/login')}>
				로그인 하러가기
			</S.NextButton>
		</S.FormContainer>
	);
};

export default SignUpComplete;
